import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-generic-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generic-form.component.html',
  styleUrl: './generic-form.component.css'
})
export class GenericFormComponent {
  @Input() title: string = '';
  @Input() titleSize : number = 24;
  @Input() showBorder: boolean = true;
  @Input() wide: boolean = false;
}






